'use strict';

var _ = require('lodash');

var DEFAULT_OPTIONS = {
  maxWidth: 200,
  metric: true,
};

function ScaleRenderer (map, options) {
  this._map = map;
  this._options = _.extend(DEFAULT_OPTIONS, options);
  this._createElement();
  this._registerListeners();
}

ScaleRenderer.prototype = {

  /**
   * Should be called when the $scope is destroyed
   */
  removeListeners: function () {
    this._map.off('moveend', this._update, this);
  },

  getElement: function () {
    var options = this._options;
    return options.metric && this._mScale || this._iScale;
  },

  _createElement: function () {
    var options = this._options;
    var tpl = [
      '<div>',
        '<div class="bar">',
          '<div class="bar-half bar-half-first"></div>',
          '<div class="bar-half bar-half-second"></div>',
        '</div>',
        '<span class="label"></span>',
      '</div>'
    ].join('');

    if (options.metric) {
      this._mScale = angular.element(tpl);
      this._mScale.addClass('metric');
    } else {
      this._iScale = angular.element(tpl);
      this._iScale.addClass('imperial');
    }

    // we need to initialize the scale or it won't appear correctly until we zoom the map
    this._update();
  },

  _registerListeners: function () {
    this._map.on('moveend', this._update, this);
  },

  _update: function () {
    var map = this._map;
    var options = this._options;
    var y = map.getSize().y / 2;

    var latlng1 = map.containerPointToLatLng([0, y]);
    var latlng2 = map.containerPointToLatLng([options.maxWidth, y]);
    var maxMeters = latlng1.distanceTo(latlng2);

    this._updateScales(maxMeters);
  },

  _updateScales: function (maxMeters) {
    var options = this._options;
    if (options.metric && maxMeters) {
      this._updateMetric(maxMeters);
    } else if (maxMeters) {
      this._updateImperial(maxMeters);
    }
  },

  _updateMetric: function (maxMeters) {
    var meters = this._getRoundNum(maxMeters);
    var label = meters < 1000 ? meters + ' m' : (meters / 1000) + ' km';

    this._updateScale(this._mScale, label, meters / maxMeters);
  },

  _updateImperial: function (maxMeters) {
    var maxFeet = maxMeters * 3.2808399,
        maxMiles, miles, feet;

    if (maxFeet > 5280) {
      maxMiles = maxFeet / 5280;
      miles = this._getRoundNum(maxMiles);
      this._updateScale(this._iScale, miles + ' mi', miles / maxMiles);

    } else {
      feet = this._getRoundNum(maxFeet);
      this._updateScale(this._iScale, feet + ' ft', feet / maxFeet);
    }
  },

  _updateScale: function (scale, text, ratio) {
    var options = this._options;
    var barEl = scale.children().eq(0);
    var labelEl = scale.children().eq(1);

    barEl.css('width', Math.round(options.maxWidth * ratio) + 'px');
    labelEl.text(text);
  },

  _getRoundNum: function (num) {
    var pow10 = Math.pow(10, (Math.floor(num) + '').length - 1),
        d = num / pow10;

    d = d >= 10 ? 10 :
        d >= 5 ? 5 :
        d >= 3 ? 3 :
        d >= 2 ? 2 : 1;

    return pow10 * d;
  }
};

module.exports = ScaleRenderer;



// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/controls/lib/ScaleRenderer.js